// extracted by mini-css-extract-plugin
export default {"academy":"academy_academy__e6DPQ"};